import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateContentDiff } from '../../../../features/componentFeatures/renderHearingSlice';
import { resolveField } from '../../../../utilities/componentResolver';
import { validationRuleByFieldId } from '../../../../features/apiFeatures/validationRuleSlice';
import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';
import { resolveValidationRules } from '../../../../utilities/validationRuleHelper';
import { CONTENTTYPE_TEXT } from '../../../../constants/api';

const Field = ({ fieldData, isEditMode }) => {
  const dispatch = useDispatch();

  const fieldType = fieldData.type;
  const ResolvedField = resolveField(fieldType);
  const validationEntity = useSelector(
    validationRuleByFieldId(getEntityId(fieldData)),
  );

  useEffect(() => {
    if (isEditMode) {
      const { canBeEmpty } = resolveValidationRules(validationEntity);
      const [textContent] = fieldData.textContent || [];
      const textValue = getAttr(textContent, 'textContent');
      if (canBeEmpty !== undefined && !canBeEmpty && !textValue) {
        dispatch(
          updateContentDiff({
            contentType: CONTENTTYPE_TEXT,
            content: '',
            fieldId: fieldData.id,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode]);

  const onChange = (newValue, contentType, allowMultiple, isDeleteOperation) =>
    dispatch(
      updateContentDiff({
        contentType: contentType,
        content: newValue,
        fieldId: fieldData.id,
        allowMultiple,
        isDeleteOperation,
      }),
    );

  if (ResolvedField !== null) {
    return (
      <ResolvedField
        fieldData={fieldData}
        onChange={onChange}
        isEditMode={isEditMode}
        validationEntity={validationEntity}
      />
    );
  }
  return null;
};

export { Field };
